import Footer from './Footer/Footer';
import Navigation from './Navigations/Navigation';

import './Layout.scss';
import Background from '../../features/SubsiteHexagons/Background/Background';
import SideNavigation from './SideNavigation/SideNavigation';
import useLayout from './hooks/useLayout';

interface LayoutProps {
  children: JSX.Element;
}

function Layout({ children }: LayoutProps) {
  const { checked, isVerified, isSideNavigationVisible } = useLayout();

  return (
    <>
      <Navigation is_subscribed={checked} is_verified={isVerified} />
      {isSideNavigationVisible && <SideNavigation is_subscribed={checked} />}
      <main className={`w-100 ${isSideNavigationVisible ? 'marginLeft' : ''}`}>
        <Background />
        {children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;
